import { useTranslation } from 'next-i18next';
import { FC } from 'react';

import { Button } from '@/components/shared/Button';
import { Icons, IconsTypes } from '@/components/shared/Icons';
import { Link } from '@/components/shared/Link';
import { formatPathname } from '@/helpers/routing';
import { Colors, INews } from '@/types';

interface INewsCardProps {
  news: INews;
}

const NewsCard: FC<INewsCardProps> = ({ news: { name, body, page_slug } }) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col rounded-lg bg-white px-4.5 py-6">
      <h3 className="mb-3.5 text-xs font-semibold uppercase text-green md:text-md">{t('text.welcomeText')}</h3>
      <h2 className="mb-3.5 text-3xl font-extrabold text-black-800 md:text-4xl">{name}</h2>
      <p className="mb-6 text-base font-medium !leading-[21px] text-black-700 md:text-md md:!leading-[25px]">{body}</p>
      <Link href={formatPathname(page_slug)}>
        <Button className="flex items-center [&>svg]:ml-4" variant={Colors.secondary}>
          {t('buttons.find-out-more')}{' '}
          {Icons({ name: IconsTypes.ARROW_RIGHT, iconProps: { className: 'text-black-600' } })}
        </Button>
      </Link>
    </div>
  );
};

export default NewsCard;
